// Demo data for state

export const demoState = {
  form: {
    name: 'Chan Wai Lok',
    dateOfBirth: '1990-01-01',
    idType: 'macau_id_card',
    id: '12345678',
    gender: 'm',
    sourceOfBusiness: 'social_media',
    sourceOfBusinessOther: '',
    address: '123 Macau',
    phone: '12345678',
    email: 'volarcheung.jobs@gmail.com',
    referralCode: '61234567',
    insuredPersons: [
      {
        name: 'Chan Wai Lok',
        dateOfBirth: '1990-01-01',
        id: '12345678',
        idType: 'macau_id_card',
        gender: 'm',
        relationship: 'self',
      },
      {
        name: 'Yip Wing Yee',
        dateOfBirth: '1995-03-16',
        id: '12345678',
        idType: 'macau_id_card',
        gender: 'f',
        relationship: 'spouse',
      },
      {
        name: 'Chan Ka Him',
        dateOfBirth: '2010-08-24',
        id: '12345678',
        idType: 'macau_id_card',
        gender: 'm',
        relationship: 'child',
      },
      {
        name: 'Chan Wing Tung',
        dateOfBirth: '2012-06-11',
        id: '12345678',
        idType: 'macau_id_card',
        gender: 'f',
        relationship: 'child',
      },
    ],
  },
};
